export default {
  methods: {
    getDate(value) {
      let date = value.toLocaleString("es-co", {
        day: "2-digit",
        year: "numeric",
        month: "2-digit"
      });
      return date;
    },
    getTime(value) {
      if (!value) {
        return 'No'
      }
      let date = value.toLocaleString("es-co", {
        hour: "2-digit",
        minute: "2-digit"
      });
      return date;
    },
    getDatetime(value) {
      if (!value) {
        return '';
      }
      let date = new Date(value);
      return date.toISOString().replace("T", " ").slice(0, 16);  
    },
    getDateTime(value) {
      if (!value) {
        return '';
      }
      return new Date(value).toLocaleString("es-co", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    currencyFormat(n) {
      if (typeof n !== "number") {
        n = 0;
      }

      return `$${n.toFixed(3)}`;
    },
    distanceFormat(n) {
      if (typeof n !== "number") {
        n = 0;
      }

      if (n === 0) {
        return `${n}Km`;
      }

      let distance = n / 1000;

      return `${distance.toFixed(2)}Km`;
    }
  }
};
